import { Outlet, createFileRoute } from '@tanstack/react-router'

import type { AuthenticatedSessionQueryData } from '@/layouts/AuthenticatedLayout/Types/types.ts'
import { AUTHENTICATED_SESSION_QUERY_KEY } from '@/lib/Queries/appQueries.ts'
import {
    requireAuthenticatedRoute,
    requireConfiguredPermissionForSession,
} from '@/lib/Routes/routeGuards.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_authenticated/admin')({
    component: RouteComponent,
    errorComponent: RouteErrorComponent,
    beforeLoad: async function ({ context, location }) {
        const session =
            context.queryClient.getQueryData<AuthenticatedSessionQueryData>(
                AUTHENTICATED_SESSION_QUERY_KEY,
            ) ?? (await requireAuthenticatedRoute(location.pathname))

        requireConfiguredPermissionForSession(
            location.pathname,
            session.permissions,
        )
    },
})

function RouteComponent() {
    return <Outlet />
}
